module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/086-nigeria-8bc8893a4781776165f611f700cd6661.svg";